<template>
  <div class="row-info">
    <!-- Always in the same place, whatever content icons the section has -->
    <v-btn
      :icon="liked ? 'mdi-heart' : 'mdi-heart-outline'"
      :color="liked ? 'primary' : 'grey'"
      size="x-small"
      variant="text"
      density="comfortable"
      class="row-info__like"
      :title="liked ? 'Retirer des favoris' : 'Ajouter aux favoris'"
      :aria-label="liked ? 'Retirer des favoris' : 'Ajouter aux favoris'"
      @click.stop="$emit('toggle-like')"
    ></v-btn>
    <div class="row-info__text">
      <div>
        <strong class="text-section-river">{{ section.river }}</strong>
        <template v-if="section.class_level">
          <span class="text-section-river"> | </span>
          <strong class="text-section-river row-info__class">{{ section.class_level }}</strong>
          <strong v-if="section.class_level_max" class="text-grey row-info__class">
            ({{ section.class_level_max }})</strong
          >
        </template>
      </div>
      <div class="row-info__name">
        <span class="font-weight-medium text-section-name">{{ section.name }}</span>
        <!-- Visible to everyone, members or not: opens the Dangers tab -->
        <v-chip
          v-if="activeDangerCount"
          color="danger"
          variant="flat"
          size="x-small"
          prepend-icon="mdi-alert"
          class="row-info__dangers"
          :title="`${dangerLabel} signalé${activeDangerCount > 1 ? 's' : ''} : voir les détails`"
          @click.stop="showDangers"
        >
          {{ dangerLabel }}
        </v-chip>
        <!-- Only the content that exists -->
        <v-icon v-if="section.video_info" color="blue" title="Vidéos disponibles" size="x-small">mdi-file-video</v-icon>
        <v-icon v-if="section.topo_info" color="blue" title="Cartes topo disponibles" size="x-small"
          >mdi-map-legend</v-icon
        >
        <v-icon v-if="section.direction_info" color="blue" title="Directions disponibles" size="x-small">
          mdi-google-maps
        </v-icon>
        <v-icon v-if="hasCamera" color="blue" title="Caméra disponible" size="x-small">mdi-webcam</v-icon>
      </div>
      <div v-if="metaParts.length" class="row-info__meta">{{ metaParts.join(" · ") }}</div>
    </div>
  </div>
</template>

<script>
  import { sectionHasCamera } from "@/utils/cameras";

  // Section cell of the river and favourite tables: like button, river / cotation, name with content icons, details.
  export default {
    name: "SectionRowInfo",
    props: {
      section: {
        type: Object,
        required: true,
      },
      liked: {
        type: Boolean,
        default: false,
      },
      showRegion: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["toggle-like"],
    methods: {
      showDangers() {
        this.$router.push({ name: "riviere", params: { slug: this.section.alias }, query: { onglet: "dangers" } });
      },
    },
    computed: {
      hasCamera() {
        return sectionHasCamera(this.section);
      },
      activeDangerCount() {
        const count = Number(this.section.active_dangers_count);
        return count > 0 ? count : 0;
      },
      dangerLabel() {
        return `${this.activeDangerCount} danger${this.activeDangerCount > 1 ? "s" : ""}`;
      },
      metaParts() {
        const rapids = Number(this.section.rapidsAmount);
        return [
          this.showRegion ? this.section.region : "",
          this.section.length ? `${this.section.length} km` : "",
          rapids > 0 ? `${rapids} rapide${rapids > 1 ? "s" : ""}` : "",
        ].filter(Boolean);
      },
    },
  };
</script>

<style scoped>
  .row-info {
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }
  /* Centred on the river name line, clear of the coloured row border */
  .row-info__like {
    margin: 0.5px 0 0 0;
    flex: 0 0 auto;
  }
  .row-info__text {
    min-width: 0;
  }
  .row-info__class {
    font-size: 0.85rem;
  }
  .row-info__name {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }
  .row-info__dangers {
    font-weight: 600;
  }
  .row-info__meta {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  }
</style>
